// extracted by mini-css-extract-plugin
export default {"pagination":"CustomPagination_pagination__C-Q8k","activated":"CustomPagination_activated__gnFZm"};